import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import type { AssignmentChangeLog } from "@/types/assignmentChangeLog.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";

export const useFetchAssignmentChangeLogs = (
    caseUUID: string | null,
): UseQueryResult<AssignmentChangeLog[]> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["assignment-changes", caseUUID],
        enabled: !!caseUUID,
        queryFn: async ({ signal }) => {
            if (!caseUUID) {
                return [];
            }

            const url = apiUrl(`/case/assignment-changes/${caseUUID}`);

            const response = await fetch(url, {
                signal,
                headers: {
                    accept: "application/json",
                },
            });

            return await response.json();
        },
        staleTime: 30_000, // 30 seconds - assignment changes are fairly static once created
        gcTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
    });
};
